import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

export const ChipContainer = styled.div`
  display: flex;
`;

export const ChipChild = styled.label`
  height: 34px;
  display: flex;
  align-items: center;
  background-color: ${props => {
    if (props.disabled && !props.selected) {
      return 'transparent';
    }

    if (props.selected) {
      return '#00619E';
    }

    return '#FFFFFF';
  }};
  border: 1px solid;
  border-color: ${props => {
    if (props.error) {
      return '#E03131';
    }

    if (props.selected) {
      return '#00619E';
    }

    return '#D9DDE9';
  }};
  border-radius: 6px;
  color: ${props => (props.selected ? '#FFFFFF' : '#183558')};
  padding: 0 12px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-right: 4px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`;

export const Header = styled.div`
  font-size: 10px;
  font-weight: 450;
  line-height: 12px;
  letter-spacing: 0;
  text-align: left;
  text-transform: uppercase;
  color: ${props => (props.error ? '#E03131' : '#6D7184')};
  margin-bottom: 8px;
`;

export const ErrorMessage = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  color: #e03131;
  display: ${props => (props.error ? 'block' : 'none')};
`;

const ChipSelection = ({
  options,
  onChange,
  header,
  error,
  value,
  name,
  disabled,
  touched,
  'data-cv-test-override': cvDataTestOverride,
  ...rest
}) => {
  const touchedError = touched ? error : null;

  return (
    <>
      <Header error={touchedError} id={name}>
        {header}
      </Header>
      <ChipContainer>
        {options.map(option => (
          <ChipChild
            htmlFor={option.value}
            key={option.value}
            selected={value === option.value}
            error={touchedError}
            disabled={disabled}
          >
            {option.label}
            <input
              type="radio"
              name={name}
              id={option.value}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              disabled={disabled}
              data-cv-test={cvDataTestOverride || rest['cv-data-test']}
            />
          </ChipChild>
        ))}
      </ChipContainer>
      <ErrorMessage error={touchedError}>{error}</ErrorMessage>
    </>
  );
};

ChipSelection.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  'data-cv-test-override': PropTypes.string
};

ChipSelection.defaultProps = {
  error: '',
  value: '',
  disabled: false,
  touched: false,
  'data-cv-test-override': null
};

export default ChipSelection;
